export const crestTypes = ['Myth', 'Hero', 'Champion', 'Veteran'] as const

type CrestType = typeof crestTypes[number]
export default CrestType
